export default "__VITE_ASSET__f4424f35__"